import React from 'react';
import { t } from 'i18next';

class MeetingTimer extends React.Component {
  constructor(props) {
    super(props);
    const { hrs, mins } = this.initialTimes();
    this.state = {
      timer_hrs: hrs,
      timer_mins: mins,
      time_spend: parseInt(this.props.meeting.time_spent) || 0,
      seconds: 0,
      total_seconds: parseInt(this.props.meeting.duration) || 0,
      timerTextStatus: parseInt(this.props.meeting.timer_counter) || 0,
      showCountPopup: false,
      playWidth: (window.innerWidth > 1366) ? '58%' : '68%',
      text: t('Count up')
    };
    this.initialTimes = this.initialTimes.bind(this);
    this.getHoursMins = this.getHoursMins.bind(this);
    this.calcHoursMins = this.calcHoursMins.bind(this);
    this.timerListPopupClose = this.timerListPopupClose.bind(this);
    this.timerCounter = this.timerCounter.bind(this);
    this.clearStates = this.clearStates.bind(this);
    this.changeCount = this.changeCount.bind(this);
    this.isNumber = this.isNumber.bind(this);
    this.onBlurEvent = this.onBlurEvent.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.startInterval = this.startInterval.bind(this);
    this.onStop = this.onStop.bind(this);
    this.clearTimeInterval = this.clearTimeInterval.bind(this);
    this.tick = this.tick.bind(this);
    this.restart = this.restart.bind(this);
    this.updateTimeSpend = this.updateTimeSpend.bind(this);
    this.updateTimerStatus = this.updateTimerStatus.bind(this);
    this.getMeetingDuration = this.getMeetingDuration.bind(this);
    this.showCountPopup = this.showCountPopup.bind(this);
  }

  componentDidMount() {
    const { meeting, currentUser, userPermission } = this.props;

    if (meeting.status == '1') {
      if (meeting.owner == currentUser.id || userPermission.isAdmin) {
        if (meeting.timer_status == '1') {
          this.startInterval();
        }
      } else {
        this.counterInterval = setInterval(this.getMeetingDuration, 10000);
      }
    }

    const meetingDuration = parseInt(meeting.duration);
    const meetingTimeSpent = parseInt(meeting.time_spent);
    this.countup = meetingTimeSpent > meetingDuration;

    this.setState({
      text: meeting.timer_counter == '1' ? t('Count up') : t('Count down')
    })

    window.addEventListener('click', this.timerListPopupClose, true);
  }

  componentWillUnmount() {
    this.clearTimeInterval();
    if (this.counterInterval) {
      clearInterval(this.counterInterval);
    }
    this.countup = false;

    window.removeEventListener('click', this.timerListPopupClose, true);
  }

  initialTimes() {
    const { meeting } = this.props;
    const timespend = meeting.time_spent || 0;
    return this.getHoursMins(meeting.duration, timespend, meeting.timer_counter);
  }

  getHoursMins(duration, timespend, timer_counter) {
    let hrs = 0; let
      mins = 0;
    if (timer_counter == '2') {
      duration = parseInt(duration);
      if (duration > timespend) {
        timespend = duration - timespend;
      } else {
        timespend -= duration;
      }
    }
    if (timespend > 0) {
      const hoursMins = this.calcHoursMins(timespend);
      hrs = hoursMins.hrs;
      mins = hoursMins.mins;
    }
    hrs = hrs < 10 ? `0${hrs}` : hrs;
    mins = mins < 10 ? `0${mins}` : mins;
    return { hrs, mins };
  }

  calcHoursMins(seconds = 0) {
    let mins = Math.ceil(seconds / 60);
    let hrs = Math.floor(seconds / 3600);
    if (mins % 60 == 0) {
      hrs += 1;
    }
    mins %= 60;
    return { hrs, mins };
  }

  timerListPopupClose(e) {
    const _this = this;
    const meetingTimerContainer = $('#countpopupWrap');
    const meetingTimerCount = $('.countSel');
    if (((!$(meetingTimerContainer).is(e.target) && $(meetingTimerContainer).has(e.target).length === 0
            && !$(meetingTimerCount).is(e.target) && $(meetingTimerCount).has(e.target).length === 0))) {
      setTimeout(() => {
        _this.setState({
          showCountPopup: false,
        });
      }, 10);
    }
  }

  timerCounter(counter) {
    const { meeting, actions } = this.props;
    const timer_count = counter == 1 ? 1 : 2;
    this.clearTimeInterval();
    this.clearStates();
    actions.MeetingUpdateTimerCounter({ timer_count });
    $.post(`${wbConfig.baseUrl}/meeting/updateMeetingCounting`, { id: meeting.id, timer_counter: timer_count }, (resp) => {
      actions.MeetingUpdateTimerCounter(resp.data);
    });

    const { showCountPopup } = this.state;
    this.setState({
      showCountPopup: !showCountPopup,
    });
  }

  clearStates() {
    this.setState({
      timer_hrs: '00',
      timer_mins: '00',
      time_spend: 0,
      seconds: 0,
      total_seconds: 0,
    });
    this.countup = false;
  }

  changeCount(e, format) {
    const v = e.target.value;
    if (v && !this.isNumber(v)) {
      e.preventDefault();
    } else {
      this.setState({
        [`${format}`]: v,
      });
    }
  }

  isNumber(val) {
    return val && /^\d+$/.test(val);
  }

  onBlurEvent(e, format) {
    const html = event.target.value;
    if (html == '') {
      this.setState({
        [`${format}`]: '00',
      });
    } else if (html == '00') {
      this.setState({
        [`${format}`]: '',
      });
    }
  }

  onPlay() {
    const { meeting } = this.props;
    const hrs = parseInt(this.state.timer_hrs);
    const mins = parseInt(this.state.timer_mins);
    if (hrs > 23) {
      alert(t('Please enter the hours value should be less than 24.'));
      return false;
    }
    if (mins > 59) {
      alert(t('Please enter the minutes value should be less than 60.'));
      return false;
    }
    const total_seconds = parseInt(this.state.total_seconds);
    if (total_seconds == 0 && meeting.timer_counter == '2') {
      const total_secs = hrs * 3600 + mins * 60;
      this.setState({ total_seconds: total_secs });
      this.updateTimerStatus(1, hrs, mins);
    } else {
      this.updateTimerStatus(1);
    }
    this.startInterval();
  }

  startInterval() {
    if (!this.interval) {
      this.interval = setInterval(this.tick, 1000);
    }
  }

  onStop() {
    const { seconds } = this.state;
    const time_spend = parseInt(this.state.time_spend);

    this.setState({
      seconds: 0,
      time_spend: (time_spend + seconds),
    });
    
    this.updateTimerStatus(0);
    this.clearTimeInterval();
  }

  clearTimeInterval() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = false;
    }
  }

  tick() {
    const { meeting } = this.props;
    let hrs = parseInt(this.state.timer_hrs);
    let mins = parseInt(this.state.timer_mins);
    const { timer_counter } = meeting;
    let { seconds } = this.state;
    let { total_seconds } = this.state;
    const time_spend = parseInt(this.state.time_spend);
    seconds += 1;
    let tot_seconds = 0;
    let reset = false;
    if (timer_counter == '1') {
      tot_seconds = time_spend + seconds;
    } else if (this.countup) {
      tot_seconds = time_spend - total_seconds + seconds;
    } else {
      total_seconds -= time_spend;
      if (total_seconds == seconds) {
        this.restart();
        tot_seconds = 0;
        this.countup = true;
        reset = true;
      } else {
        tot_seconds = total_seconds - seconds;
      }
    }
    if (reset) {
      hrs = 0;
      mins = 0;
      reset = false;
    } else {
      const hoursMins = this.calcHoursMins(tot_seconds);
      hrs = hoursMins.hrs;
      mins = hoursMins.mins;
    }
    mins = mins < 0 ? 0 : mins;
    hrs = hrs < 0 ? 0 : hrs;
    mins = mins < 10 ? `0${mins}` : mins;
    hrs = hrs < 10 ? `0${hrs}` : hrs;
    if (seconds % 10 == 0) {
      this.updateTimeSpend();
    }
    this.setState({
      timer_hrs: hrs, 
      timer_mins: mins, 
      seconds,
    });
  }

  restart() {
    this.setState({
      seconds: 0,
    });
  }

  updateTimeSpend() {
    const { meeting, actions } = this.props;
    if (meeting.status == 1) {
      $.post(`${wbConfig.baseUrl}/meeting/updateMeetingTimespent`, { id: meeting.id }, (resp) => {
      });
    }
  }

  updateTimerStatus(timer_status, hrs = 0, mins = 0) {
    const { meeting, actions } = this.props;
    const _this = this;
    actions.MeetingUpdateTimerStatus(meeting.id, { timer_status });
    $.post(`${wbConfig.baseUrl}/meeting/updateMeetingTimerStatus`, {
      id: meeting.id, timer_status, hrs, mins,
    }, (resp) => {
      actions.MeetingUpdateTimerStatus(meeting.id, resp.data);
      if (typeof resp.data.duration !== 'undefined') {
        const duration = parseInt(_this.props.meeting.duration) || 0;
        hrs = Math.floor(duration / 3600);
        mins = Math.floor(duration / 60);
        const updateData = { total_seconds: duration };
        if (timer_status != '1') {
          updateData.timer_hrs = hrs < 10 ? `0${hrs}` : hrs;
          updateData.timer_mins = mins < 10 ? `0${mins}` : ((mins == 60) ? '00' : mins);
        }
        _this.setState(updateData);
      }
    });
  }

  getMeetingDuration() {
    const _this = this;
    // clear intervals if not in meeting details page.
    if (!$('.meetingDetailsMainDiv').length && this.counterInterval) {
      clearInterval(this.counterInterval);
      return;
    }
    const { meeting } = this.props;
    $.ajax({
      url: `${wbConfig.baseUrl}/meeting/getMeetingDuration`,
      type: 'get',
      data: { id: meeting.id },
    })
      .done((resp) => {
        if (resp.error) {
          // TODO: clean this conditional up
        } else {
          const { hrs, mins } = _this.getHoursMins(resp.duration, resp.time_spent, resp.timer_counter);
          _this.countup = parseInt(resp.time_spent) > parseInt(resp.duration);
          _this.setState({
            timer_hrs: hrs,
            timer_mins: mins,
            timerTextStatus: resp.timer_counter,
          });
        }
      });
  }

  showCountPopup(e) {
    const { showCountPopup } = this.state;
    const { meeting } = this.props;
    const newCounterType = meeting.timer_counter == '1' ? '2' : '1';
    this.setState({
      showCountPopup: !showCountPopup,
      text: newCounterType == '1' ? t('Count up') : t('Count down')
    });

    this.timerCounter(newCounterType);
  }

  updateTimer(e) {
    const { meeting, currentUser, userPermission } = this.props;
    const meetingOwner = meeting.owner;
    const editTimer = (meetingOwner == currentUser.id || userPermission.isAdmin);
    if (!editTimer || meeting.status != '1') {
      return;
    }
    const newCounterType = meeting.timer_counter == '1' ? '2' : '1';
    this.timerCounter(newCounterType)
    this.setState({
      text: newCounterType == '1' ? t('Count up') : t('Count down')
    })
  }

  render() {
    const { meeting, currentUser, userPermission } = this.props;
    const meetingOwner = meeting.owner;
    const editTimer = (meetingOwner == currentUser.id || userPermission.isAdmin);
    let showOvertime = false;
    if (editTimer) {
      showOvertime = (this.countup && meeting.timer_counter == '2');
    } else {
      showOvertime = (this.countup && this.state.timerTextStatus == '2');
    }
    const meetingDuration = parseInt(meeting.duration);
    const timerStatus = parseInt(meeting.timer_status);
    const disabledText = (meeting.status != '1') ? true : (!((editTimer && meeting.status == '1' && meeting.timer_counter == '2' && !meetingDuration)));
    const handCursor = (editTimer && meeting.status == '1') ? 'pointer' : 'default';

    let titleStyle = { fontSize: 12, fontWeight: 'bold', paddingLeft: 2, cursor: 'pointer', color: '#6c8699', paddingTop: '1px' };
    if (window.wbConfig.isNewMeetingsEnabled) {
      titleStyle = { fontSize: '14px', fontWeight: 'bold', paddingLeft: 2, cursor: 'pointer', minWidth: '130px' };
    }

    return (
      <div className="meeting-timer-section">
        <div onClick={e => this.showCountPopup(e)} style={titleStyle}>
          {this.state.text}
          <img style={{ position: 'absolute', marginLeft: 9 }} src={`${wbConfig.baseUrl}/images/meeting_assets/ic/chevron/small/up/grey_copy.png`} width="20" height="20" />
        </div>

        <div className="meeting-timer-textbox">
          {
            this.state.showCountPopup && editTimer && meeting.status == '1' && (
            <div id="countpopupWrap" className="countpopupWrap" style={{ cursor: handCursor }}>
              <div className="countType" data-counter={meeting.timer_counter} onClick={this.updateTimer}>{this.state.text}</div>
            </div>
            )
          }

          <div className={`left meet-timer-wrapper ${showOvertime ? ' meet-timer-overtime ' : ''}`}>
            <span className="meet-timer-input left"><input type="text" disabled={disabledText ? 'disabled' : false} onBlur={e => this.onBlurEvent(e, 'timer_hrs')} onClick={e => this.onBlurEvent(e, 'timer_hrs')} onChange={e => this.changeCount(e, 'timer_hrs')} maxLength={2} value={this.state.timer_hrs} /></span>
            <span className="meet-timer-sep left">:</span>
            <span className="meet-timer-input left"><input type="text" disabled={disabledText ? 'disabled' : false} onBlur={e => this.onBlurEvent(e, 'timer_mins')} onClick={e => this.onBlurEvent(e, 'timer_mins')} onChange={e => this.changeCount(e, 'timer_mins')} maxLength={2} value={this.state.timer_mins} /></span>
          </div>
          <div className="left">
            {
              (editTimer && meeting.status == '1')
                ? (timerStatus != '1')
                  ? <div className="meet-play-button clickable" onClick={() => this.onPlay()} />
                  : <div className="meet-stop-button clickable" onClick={() => this.onStop()} />
                : ''
            }
            {
              (editTimer && meeting.status != '1')
                ? (timerStatus != '1')
                  ? <div className="meet-play-button" />
                  : <div className="meet-stop-button" />
                : ''
            }
          </div>
        </div>
      </div>
    );
  }
}
export default MeetingTimer;
